import { actionAuth } from "../../../../redux/actions/auth";

export const AuthContainer = (dispatch) => ({
  loginSuccesful: (data) => {
    dispatch(actionAuth.LoginSuccess(data));
  },
});
